<style scoped>

.button-row {
  margin: 16px 0 0 0;
}
</style>

<template>
  <b-row>
    <b-modal
      id="sent-files"
      header-class="anchor-modal"
      title="Financial Statement - Upload Files"
      v-model="showModal"
      hide-footer
      @hidden="close"
      :no-close-on-backdrop="modalNoCloseOnBackdrop"
      :no-close-on-esc="modalNoCloseOnEsc"
      :hide-header-close="modalHideHeaderClose"
    >
      <b-row>
        <b-col>
          <vue-form-generator
            :schema="schema"
            :options="formOptions"
            :model="model"
            ref="form"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <upload
            v-if="model.date"
            class="mx-0"
            @success="onSuccess"
            @cancel="cancelUploadByUser"
            @change="showSendButton = $event.length > 0"
            ref="upload"
            :showSubmitButton="false"
            :multiple="false"
            :params="parameter"
          />
        </b-col>
      </b-row>
      <b-row class="button-row">
        <b-col>
          <submit-button
            v-if="showSendButton"
            title="Submit"
            @submit="sendDocument"
          />
        </b-col>
      </b-row>
    </b-modal>
  </b-row>
</template>

<script>
import helper from '@/libs/helper';

import SubmitButton from '@/components/utils/buttons/form/SubmitButton';
import Upload from '@/components/utils/upload/Upload';
import uploadValidatorMixin from '@/components/utils/upload/uploadValidatorMixin';
import FINANCIAL_STATEMENT_SCHEMA from '@/components/documents/resources/schema';
import FINANCIAL_STATEMENT_MODEL from '@/components/documents/resources/financial_statement.json';


export default {
  name: 'FinancialStatementDocuments',
  mixins: [uploadValidatorMixin],
  components: {
    Upload,
    SubmitButton,
  },
  data() {
    return {
      showModal: false,
      showSendButton: false,
      schema: FINANCIAL_STATEMENT_SCHEMA.schema,
      formOptions: FINANCIAL_STATEMENT_MODEL.options,
      model: this.getModel(),
      modalNoCloseOnBackdrop: false,
      modalNoCloseOnEsc: false,
      modalHideHeaderClose: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    parameter() {
      return {
        net_worth: this.model.net_worth,
        type: 'Financial Statement',
        doc_date: this.model.date,
      };
    },
  },
  methods: {
    open() {
      this.showCancelUploadButton = false;
      this.modalNoCloseOnBackdrop = false;
      this.modalNoCloseOnEsc = false;
      this.showModal = true;
    },
    close() {
      this.showModal = false;
      this.reset();
    },
    reset() {
      this.model = this.getModel();
    },
    getModel() {
      return helper.copy(FINANCIAL_STATEMENT_MODEL);
    },
    onSuccess() {
      this.close();
      this.$emit('success');
    },
    cancelUploadByUser() {
      this.showModal = false;
    },
    sendDocument() {
      if (this.$refs.form.validate()) {
        this.showSendButton = false;
        this.modalNoCloseOnBackdrop = true;
        this.modalNoCloseOnEsc = true;
        this.modalHideHeaderClose = true;
        this.$refs.upload.send(`/users/${this.user.id}/docs`);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/documents/FinancialStatementUpload.vue